import React from 'react';
import { Layout } from 'antd';
import Sidebar from 'components/Sidebar/Sidebar';
import { RouteRedirect } from '@unicus/react-ui-kit';
import 'components/IconLibrary';
import TopbarAdmin from 'components/Topbar/TopbarAdmin';
import useAuth from 'core/hooks/useAuth';
import { Routes } from 'components/routes';

const { Content } = Layout;

const AdminContainer = (props) => {
  const { match, routes, roles, basePath, restrictRoles = [] } = props;
  const { isAuthenticated, isAdmin, tenantId } = useAuth();

  const onBeforeRouteRender = () => {
    if (isAuthenticated && !isAdmin() && tenantId) {
      return <RouteRedirect to="/app" />;
    }

    return null;
  };

  return (
    <Layout className="gx-app-layout">
      <Sidebar routes={routes} match={match} />
      <Layout>
        <TopbarAdmin routes={routes} match={match} />
        <Content className="gx-layout-content gx-container-wrap">
          <Routes
            match={match}
            routes={routes}
            roles={roles}
            basePath={basePath}
            restrictRoles={restrictRoles}
            onBeforeRouteRender={onBeforeRouteRender}
            isContainer
          />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminContainer;
